import React, { useEffect, useState } from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import bannerHero from './../assets/nevels2.png';
import { Link } from 'react-router-dom';
import MainFooter from '../Components/footer/MainFooter';
import { Helmet } from 'react-helmet';

function Blogs() {

    const [blogList, setBlogList]                                    = useState([]);
    const [processing, setProcessing]                                = useState(false);

    useEffect(() => {
        collectBlogListing()
    },[]);

    const collectBlogListing = async () => {
        try{
            setProcessing(true);
            const response = await axios.get(CONSTANTS.URL_BLOG +"wp-json/ts/lovedripblg/blogs/v1/posts");
            console.log(response);
            setBlogList(response.data);
            setProcessing(false);
        }catch(err){
            console.log(err);
            setProcessing(false);
        }
    }

  return (
    <div className="main-layer">
        <Helmet>
            <title>Lovedripp - Blogs </title>
        </Helmet>
        <TopNavigation title={"Blogs"} classBack="full-white" />
        <div className="content-layer">
            <div className="banner-photo-show middle-align txt-white" 
                style={{backgroundImage: `url("${bannerHero}")`}}>     
                <div className="info-hero-intro">
                    <h1 className="head-styling-font">Love life blogs</h1>
                    <div className="sub-text-hero">
                      Read up on our blogs
                    </div>
                </div>                 
            </div>
            
            <div className="section-item">             
                <div className="container">
                  {
                    blogList.length > 0 && (
                        <div className="row">
                            {
                                blogList.map((blog, index) => {
                                    return <div className="col-md-4" key={index}>
                                                <div className="content-part-blog" 
                                                    style={{
                                                        backgroundImage:`url(${blog.featured_image.large})`
                                                    }}>
                                                    <Link to={"/single-blog/" + blog.id} className="bl-box-item">
                                                        <div className="col-relative-overlay">
                                                            <h3 className="head-styling-font txt-white ft-45">{blog.title}</h3>
                                                        </div>
                                                    </Link> 
                                                </div>
                                            </div>
                                })    
                            }
                        </div>
                    )
                  }
                </div>
            </div>
        </div>
        {
            processing && (
                <div className="processing-spinner">
                        <img src={CONSTANTS.SMALL_PROCESSING} className="pro-spin" />
                </div>
            )
       }
       <MainFooter />
    </div>
  )
}

export default Blogs